<template>
  <Modal v-model="visible" title="推剧封面" :width="900" :mask-closable="false" @on-visible-change="handleVisibleChange" :footer-hide="true">
    <div class="promote-container">
      <div class="header-action">
        <PopupUpload mode="custom" @on-success="handleAddSuccess" :exact-width="600" :exact-height="800">
          <Button type="primary" icon="md-add">新增</Button>
        </PopupUpload>
      </div>

      <div class="card-grid">
        <div class="card-item" v-for="(item, index) in displayList" :key="item.id || index">
          <div class="cover-wrapper">
            <!-- Cover Image Container -->
            <div class="img-container" @click.stop="$viewerApi({ images: [item.coverFileUrl] })">
               <img :src="item.coverFileUrl" class="cover-img" />
               <!-- Hover Overlay for Cover (不允许修改第一项) -->
               <div class="hover-overlay">
                  <!-- 使用封面按钮 (仅非使用中的封面显示) -->
                  <div class="use-cover-btn" v-if="!item.useCover" @click.stop="handleUseCover(item)">
                    <Icon type="md-checkmark" /> 使用封面
                  </div>
                  <div @click.stop v-if="index !== 0">
                    <PopupUpload mode="custom" @on-success="(res) => handleReplaceCover(res, item)" :exact-width="600" :exact-height="800">
                      <div class="replace-btn">
                        <Icon type="md-sync" /> 替换封面
                      </div>
                    </PopupUpload>
                  </div>
               </div>
               <!-- Tag for Default -->
               <div class="default-tag" v-if="index === 0&& !item.useCover">默认</div>
               <!-- Tag for In Use -->
               <div class="in-use-tag" v-if="item.useCover">使用中</div>
               <!-- Delete Button (不允许删除第一项) -->
               <div class="delete-btn" v-if="index !== 0" @click.stop="handleDelete(item)">
                 <Icon type="md-close" />
               </div>
            </div>
            
            <!-- Button Image Container -->
            <div class="button-container">
              <img :src="item.buttonFileUrl" class="button-img" />
              <!-- Hover Overlay for Button (不允许修改第一项) -->
              <div class="hover-overlay" v-if="index !== 0">
                <PopupUpload mode="custom" @on-success="(res) => handleReplaceButton(res, item)" :exact-width="520" :exact-height="98">
                  <div class="replace-btn">
                    <Icon type="md-sync" /> 替换按钮
                  </div>
                </PopupUpload>
              </div>
            </div>
            
            <!-- Card Info (Title) -->
            <div class="card-info">
              <div class="card-name" v-if="editingItemId !== item.id">
                <span :title="item.title">{{ item.title }}</span>
                <Icon type="md-create" class="edit-icon" v-if="index !== 0" @click="startEdit(item)" />
              </div>
              <div class="name-input" v-else>
                <Input v-model="editTitle" size="small" @on-blur="saveEdit(item)" @on-enter="saveEdit(item)" ref="nameInput" />
              </div>
            </div>


          </div>
        </div>
      </div>
        <Pages :page="page" :func="handlePageChange" :pArr="[4]" />
    </div>
  </Modal>
</template>

<script>
import PopupUpload from '@/components/Upload/PopupUpload'
import { 
  getPlayPromotionCoverPage, 
  addPlayPromotionCover,
  editPlayPromotionCover,
  deletePlayPromotionCover,
  usePlayPromotionCover
} from '@/api/promote'
import Pages from '@/components/pages'

export default {
  name: 'PromoteModal',
  components: {
    PopupUpload,
    Pages
  },
  data() {
    return {
      visible: false,
      loading: false,
      playId: null,
      
      // Data from API
      displayList: [],
      
      page: {
        current: 1,
        size: 4,
        total: 0,
      },
      
      // Editing state
      editingItemId: null,
      editTitle: ''
    }
  },
  methods: {
    open(row) {
      this.playId = row.id
      this.visible = true
      this.currentPage = 1
      this.loadData()
    },
    loadData() {
      this.loading = true
      getPlayPromotionCoverPage({ 
        playId: this.playId, 
        current: this.page.current, 
        size: this.page.size 
      }).then(res => {
        this.displayList = res.data.records || []
        this.page.total = res.data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleVisibleChange(val) {
      if (!val) {
        this.displayList = []
        this.playId = null
        this.currentPage = 1
        this.total = 0
        this.editingItemId = null
      }
    },
    handlePageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    
    // Add new cover - immediate save
    async handleAddSuccess(res) {
      try {
        await addPlayPromotionCover({
          playId: this.playId,
          title: res.fileName || '未命名',
          coverFileId: res.fileId,
          buttonFileId: 0, // Default button, API should handle
          buttonText: 'Watch Now',
          sort: 0
        })
        this.$Message.success('添加成功')
        this.loadData()
      } catch (e) {
        this.$Message.error('添加失败')
      }
    },
    
    // Replace cover image - immediate save
    async handleReplaceCover(res, item) {
      try {
        await editPlayPromotionCover({
          id: item.id,
          playId: item.playId,
          title: item.title,
          coverFileId: res.fileId,
          buttonFileId: item.buttonFileId || 0,
          buttonText: item.buttonText || 'Watch Now',
          sort: item.sort || 0
        })
        this.$Message.success('替换封面成功')
        this.loadData()
      } catch (e) {
        this.$Message.error('替换封面失败')
      }
    },
    
    // Replace button image - immediate save
    async handleReplaceButton(res, item) {
      try {
        await editPlayPromotionCover({
          id: item.id,
          playId: item.playId,
          title: item.title,
          coverFileId: item.coverFileId,
          buttonFileId: res.fileId,
          buttonText: item.buttonText || 'Watch Now',
          sort: item.sort || 0
        })
        this.$Message.success('替换按钮成功')
        this.loadData()
      } catch (e) {
        this.$Message.error('替换按钮失败')
      }
    },
    
    // Delete with confirmation
    handleDelete(item) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除封面 "${item.title}" 吗？`,
        onOk: async () => {
          try {
            await deletePlayPromotionCover(item.id)
            this.$Message.success('删除成功')
            this.loadData()
          } catch (e) {
            this.$Message.error('删除失败')
          }
        }
      })
    },
    
    // Edit title
    startEdit(item) {
      this.editingItemId = item.id
      this.editTitle = item.title
      this.$nextTick(() => {
        if (this.$refs.nameInput && this.$refs.nameInput[0]) {
          this.$refs.nameInput[0].focus()
        }
      })
    },
    async saveEdit(item) {
      if (this.editTitle && this.editTitle.trim() && this.editTitle.trim() !== item.title) {
        try {
          await editPlayPromotionCover({
            id: item.id,
            playId: item.playId,
            title: this.editTitle.trim(),
            coverFileId: item.coverFileId,
            buttonFileId: item.buttonFileId || 0,
            buttonText: item.buttonText || 'Watch Now',
            sort: item.sort || 0
          })
          this.$Message.success('修改成功')
          this.loadData()
        } catch (e) {
          this.$Message.error('修改失败')
        }
      }
      this.editingItemId = null
      this.editTitle = ''
    },
    
    // Set cover as "in use"
    async handleUseCover(item) {
      try {
        await usePlayPromotionCover(item.id)
        this.$Message.success('设置成功')
        this.loadData()
      } catch (e) {
        this.$Message.error('设置失败')
      }
    }
  }
}
</script>

<style scoped lang="less">
.promote-container {
  padding: 10px;
}
.header-action {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.card-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.card-item {
  width: 150px;
  position: relative;
}
.cover-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-container {
  width: 100%;
  height: 200px; /* 3:4 roughly */
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dcdee2;
  background: #f8f8f9;
  
  &:hover .hover-overlay {
      display: flex;
  }
}
.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Button Image Container */
.button-container {
  width: 100%;
  height: 50px;
  position: relative;
  margin-top: 8px;
  border-radius: 6px;
  overflow: hidden;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  
  &:hover .hover-overlay {
    display: flex;
  }
}
.button-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.hover-overlay {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.replace-btn {
  color: #fff;
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid #fff;
  border-radius: 4px;
  font-size: 12px;
    &:hover {
        background: rgba(255,255,255,0.2);
    }
}
.default-tag {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
  color: #fff;
  padding: 2px 6px;
  font-size: 12px;
  border-bottom-right-radius: 8px;
}
.in-use-tag {
  position: absolute;
  top: 0;
  left: 0;
  background: #19be6b;
  color: #fff;
  padding: 2px 6px;
  font-size: 12px;
  border-bottom-right-radius: 8px;
}
.use-cover-btn {
  color: #fff;
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid #fff;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 8px;
  &:hover {
    background: rgba(255,255,255,0.2);
  }
}
.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #fff;
  background: #ed4014;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}
.card-info {
  width: 100%;
  margin-top: 10px;
  text-align: center;
  height: 24px;
}
.card-name {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #333;
  
  span {
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
}
.edit-icon {
  margin-left: 5px;
  cursor: pointer;
  color: #2d8cf0;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
